export default __webpack_public_path__ + "1cd0ab239069e0cb0a92da287ae9efae.ico";